
import {  Checkbox, KoDate, KoForm, KoFormBuilder, KoLoader, KoSelect, KoTextArea, KoToast, Upload } from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './estimates.module.scss';
import ItemEntryCrud from './itemEntryCrud';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';
import { Country} from 'country-state-city';
// import Driver from 'packages/drivers';




const EstimateCurd = ({form, handleFinish, initialValues }) => {
  // const [form] =KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);
  const [countriesList] = useState(Country.getAllCountries());

  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`This transaction is applicable for reverse charge`}</Checkbox>;
  const Automatic = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Create a retainer invoice for this estimate automatically `}</Checkbox>;
  const CountrySelect = ({ value, onChange }) =>
    <KoSelect showSearch value={value}
      onChange={(v) => onChange(v)}
      placeholder={'Select Country'}
      options={countriesList?.map((country) => ({
        label: country?.name,
        value: country?.isoCode
      }))} />;

  const person = [
    { label: 'ProjectKamel', value: 'projectkamel' },
    { label: 'ProjectNithish', value: 'projectnithish' },
    { label: 'ProjectSam', value: 'projectsam' },
    { label: 'ProjectRaji', value: 'projectraji' }
  ];
      
  const Salesperson= ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose a Project'
      options={person?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'ventors', label: 'Customer Name', colSpan: 2, widget: Customers },
      { key: 'primaryDetails.nationality',label: 'Place Of Supply', colSpan: 2, widget: CountrySelect },
      { key: 'purchaseorder', placeholder: 'Enter a Estimate', label: 'Estimate#' , colSpan: 2},
      { key: 'purchaseorder', placeholder: 'Enter a Reference#', label: 'Reference#' , colSpan: 2},
      { key: 'startDate', label: 'Estimate Date', colSpan: 2, widget: Date },
      { key: 'startDate', label: 'Expiry Date', colSpan: 2, widget: Date },
      { key: 'salesperson', label: 'SalePerson', colSpan: 2, widget: Customers},
      { key: 'projectname', label: 'Project Name', colSpan: 2, widget:Salesperson   },
      { key: 'reference', placeholder: 'Project a Reference', label: 'Reference#' , colSpan: 2},
      { key: 'reversecharge', colSpan: 4, label: '', widget: CheckBox },

      { key: '', label: 'Item Table', colSpan: 6, widget: () => <ItemEntryCrud form={form} handleFinish={handleFinish} initialValues={initialValues} /> },
      { key: 'description', widget: KoTextArea, label: 'Customer Notes', colSpan: 6, placeholder: 'Will be displayed on purchase order'},
      { key: 'termscondition', widget: KoTextArea, label: 'Terms & Conditions', colSpan: 6, placeholder: 'Enter the terms and conditions of your business to be displayed in your transaction'},
      { key: 'reversecharge', colSpan: 4, label: '', widget:Automatic }
    ]};




  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'documents'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }};

  const normFile = (e) => {
    return e?.file;
  };


  const uploadButton = (
    <div className={styles.dndArea}>
      <KoIcon name='AttachmentOutlined' />
      <div> Purchase Order Attach File</div>
    </div>

  );
  const onRemoveFile = (d) => {
    console.log();
  };


  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  
  return (
    <div  className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <div className={styles.attachments}>
          {/* <div className={styles.attachmentsArea}>
            <Driver DeleteFile={false} action={true} fileType={initialValues?.documents?.aadharDetails?.file?.type} filePath={initialValues?.documents?.aadharDetails?.file.url} handleDelete={() => onRemoveFile(initialValues?.documents?.aadharDetails?.file)} />
          </div> */}
        
          <KoForm.Item
            name={"file"}
            valuePropName={"file"}
            getValueFromEvent={normFile}>

            <Upload {...props}
              className={styles.card}
              onRemove={onRemoveFile}
              showUploadList={{showPreviewIcon : false}}
              showPreviewIcon={true}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </KoForm.Item>
        </div>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};
export default EstimateCurd;